<template>
  <CModal
    title="Add customer"
    size="lg"
    :show="show"
    @update:show="$emit('close')"
  >
    <CRow>
      <CCol md="6">
        <CInput
          ref="nameInput"
          label="Company name *"
          v-model="localCustomer.name"
          placeholder="e.g. Customer Sdn Bhd"
          :is-valid="fieldValid('name')"
          invalid-feedback="Enter the customer's name"
        />
        <CInput
          label="Contact name"
          v-model="localCustomer.contactName"
          placeholder="Contact person's name"
        />
        <CInput
          label="Contact email"
          v-model="localCustomer.contactEmail"
          placeholder="contact@example.com"
          type="email"
        />
        <CInput
          label="Contact phone"
          v-model="localCustomer.contactPhone"
          placeholder="012-345 6789"
          type="tel"
        />
      </CCol>
      <CCol md="6">
        <CTextarea
          ref="addressInput"
          label="Address *"
          placeholder="e.g. No. 123, Jalan Example, Taman Example"
          rows="4"
          v-model="localCustomer.address"
          :is-valid="fieldValid('address')"
          invalid-feedback="Enter the customer's address. It's printed on quotations and invoices"
        />
        <CRow>
          <CCol sm="6">
            <CInput label="City" v-model="localCustomer.city" />
          </CCol>
          <CCol sm="6">
            <CInput label="Postcode" inputmode="numeric" v-model="localCustomer.postcode" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput label="State" v-model="localCustomer.state" />
          </CCol>
          <CCol sm="6">
            <CInput label="Country" v-model="localCustomer.country" />
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <CButton color="light" @click="$emit('close')">Cancel</CButton>
        <CButton color="primary" @click="saveCustomer">Add customer</CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "CustomerFormModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localCustomer: { ...this.customer },
      submitted: false,
    };
  },
  watch: {
    customer: {
      handler(newCustomer) {
        this.localCustomer = { ...newCustomer };
      },
      deep: true,
    },
    show(newValue) {
      if (newValue) {
        this.localCustomer = { ...this.customer };
        this.submitted = false;
      }
    },
  },
  computed: {
    isValid() {
      return this.hasValue("name") && this.hasValue("address");
    },
  },
  methods: {
    hasValue(field) {
      const v = this.localCustomer[field];
      return !!(v && String(v).trim());
    },
    fieldValid(field) {
      if (!this.submitted) return null;
      return this.hasValue(field) || false;
    },
    saveCustomer() {
      this.submitted = true;
      if (this.isValid) {
        this.$emit("save", this.localCustomer);
        return;
      }
      const ref = !this.hasValue("name") ? this.$refs.nameInput : this.$refs.addressInput;
      this.$nextTick(() => {
        const el = ref && ref.$el.querySelector("input, textarea");
        if (el) el.focus();
      });
    },
  },
};
</script>
